import { css } from 'styled-components';

const rotationAnimation = () => {
  return css`
    animation-name: rotation;
    animation-duration: 1600ms;
    animation-iteration-count: infinite;
    animation-timing-function: steps(8);
    animation-delay: 50ms;

    @keyframes rotation {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(360deg);
      }
    }
  `;
};

export enum AnimationType {
  ROTATION = 'rotation',
}

export const getAnimation = (animation?: AnimationType) => {
  switch (animation) {
    case AnimationType.ROTATION:
      return rotationAnimation();
    default:
      return '';
  }
};
